import { AxiosError } from 'axios';
import type { FieldError } from 'react-hook-form';
import { MFA_EXPIRED_STATE_RESPONSE_CODE } from '@/shared/config';

export const getReactHookFormErrorMessages = (
  reactHookFormErrors: FieldError | undefined
): Array<string> => {
  const errors = new Set<string>();

  if (!reactHookFormErrors || !reactHookFormErrors.types) {
    return [];
  }

  Object.entries(reactHookFormErrors.types).forEach(([, errorValue]) => {
    if (Array.isArray(errorValue)) {
      errorValue.forEach((error: unknown) => {
        if (typeof error === 'string') {
          errors.add(error);
        }
      });
    } else if (typeof errorValue === 'string') {
      errors.add(errorValue);
    }
  });

  return [...errors];
};

export const isVerificationCodeInvalidError = (error: unknown): boolean => {
  const codeErrors = [
    'VERIFICATION_CODE_INVALID',
    'EMAIL_CODE_INVALID',
    MFA_EXPIRED_STATE_RESPONSE_CODE,
  ];
  return codeErrors.includes((error as AxiosError)?.code || '');
};
